<!--
 * @Author: lixiaodi
 * @Date: 2020-03-13 09:14:59
 * @LastEditors: lixiaodi
 * @LastEditTime: 2020-03-16 17:32:39
 -->
<template>
  <div>

  </div>
</template>

<script>
import { jump,getUser } from '@/untils/auth'
export default {
  name: 'PicShareIndex',
  data() {
    return {
    }
  },
}
</script>
<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Education/components/index/picShareIndex.vue